import React from "react";

function ComingSoon() {
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="container">
          {/* start row */}
          <div className="row justify-content-center align-items-center">
            <div className="col-md-8 d-flex align-items-center justify-content-center mx-auto p-4">
              <div
                className="card border-0 text-center mb-0"
                style={{ background: "none", boxShadow: "none" }}
              >
                <div className="card-body p-4">
                  <div className="text-center mb-4">
                    <img
                      src={`${process.env.PUBLIC_URL}/img/sansad-khel-mahotsav.webp`}
                      alt="Coming Icon"
                      style={{ width: "200px" }}
                    />
                  </div>
                  <h3 className="text-body mb-2">This Page is</h3>
                  <h1 className="display-2 fw-bold mb-2">
                    <span className="text-primary"> COMING </span> SOON{" "}
                  </h1>
                  <p className="text-dark mb-0">
                    Please check back later, We are working hard to get <br />{" "}
                    everything just right.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComingSoon;
